export default function normalizeParsedToken(token) {
  return {
    token: token.vjResponse.token,
  };
}
